
  // jQuery(document).ready(function($) {
  //       $('.cart-reviews-slider').slick({
  //         dots: true,
  //         infinite: true,
  //         speed: 2000,
  //         slidesToShow: 2.2,
  //         slidesToScroll: 1,
  //         autoplay: false,
  //         autoplaySpeed: 2000,
  //         arrows: true,
  //         responsive: [{
  //           breakpoint: 1500,
  //           settings: {
  //             slidesToShow: 2,
  //             arrows: false,
  //             slidesToScroll: 1
  //           }
  //         },
  //         {
  //            breakpoint: 1200,
  //            settings: {
  //               arrows: false,
  //               slidesToShow: 1,
  //               slidesToScroll: 1
  //            }
  //         }]
  //     });
  // });

 // reviews slider



  new Swiper(".cart-reviews-slider", {
    loop: false,
    pagination: { el: ".custom-blogs-slider-hp .swiper-pagination", clickable: true },
    spaceBetween: 20,

   breakpoints: {
        320: { slidesPerView: "1" }, // Mobile
        768: { slidesPerView: "1" }, // iPad
        1024: { slidesPerView: "2" }, // Laptop
        1600: { slidesPerView: "2.5" }, // Large screens
      },
     scrollbar: {
         el: '.swiper-scrollbar',
         draggable: true,
         dragSize: 100,
         snapOnRelease: false // Prevent snapping to the nearest slide
       }

    
  });




    // const swiper = new Swiper(containerSelector, {
    //   slidesPerView: 1.5, // Adjust based on layout
    //   spaceBetween: 10, // Spacing between slides
    //   navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    //   },
    //   pagination: {
    //     el: '.swiper-pagination',
    //     clickable: true,
    //   },
    //   breakpoints: {
    //     1024: {
    //       slidesPerView: 1.5,
    //     },
    //     768: {
    //       slidesPerView: 1.5,
    //     },
    //     480: {
    //       slidesPerView: 1.5,
    //     },
    //   },
    //   loop: false, // Infinite loop scrolling
    // });